<div class="sync-fusion-main-container">
    <!-- <app-header-content-help-text [Heading]="heading" [helpText]="helpText"></app-header-content-help-text> -->
    <div class="fs-section-block fs-margin-0 header-background" style="margin-bottom: 0px!important;">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <span class="mat-headline">{{heading}}</span>
                <p class="fs-hint-text">{{helpText}}</p>
            </div>
            <button *ngIf="formData?.id" class="mat-button mat-primary mat-raised-button create-btn"
                (click)="createNewSop()"> Create Digital
                SOP
            </button>
        </div>
    </div>
    <div class="sop-list-container" [class.collapsed]="isCollapsed">
        <div class="left-column">
            <div class="d-flex flex-row align-items-center">
                <div class="search-container">
                    <input matInput [(ngModel)]="searchText" (input)="onSearchInputChange()"
                        placeholder="Search by name/part number/station" />
                    <mat-icon style="cursor: pointer;" matSuffix
                        (click)="searchText ? clearSearch() : onSearchInputChange()"> {{
                        searchText ? 'close' : 'search' }}</mat-icon>
                </div>
                <div class="actions">
                    <div class="breadcrumbs-container" (click)="toggleLeftColumn()">
                        <mat-icon>{{ isCollapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left'
                            }}</mat-icon>
                    </div>
                </div>
            </div>
            <ul class="sop-li">
                <li class="sop-list d-flex justify-content-between " [class.active]="i === activeIndex"
                    (click)="handleItemClick(item, i)"
                    [ngStyle]="{'color': item.active && i === activeIndex ? '#ffffff' : (item.active ? '#ffa000' : ''),'font-weight': i === activeIndex ? 'bold' : 'normal'}"
                    *ngFor="let item of sopList; let i = index">
                    <span class="list-item">{{item.name}}</span>
                </li>
            </ul>
            <!-- <div class="actions">
                <div class="breadcrumbs-container" (click)="toggleLeftColumn()">
                    <mat-icon>{{ isCollapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</mat-icon>
                  </div>  
            </div> -->
        </div>
        <div class="right-column">
            <app-digital-sop-form-molecule *ngIf="renderSop" [formData]="formData"
                (sopUpdated)="onSopUpdated($event)"></app-digital-sop-form-molecule>
        </div>
    </div>
</div>